import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const InboxOutlineIcon = (props: IconProps) => (
  <Icon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <path d="M15.8333 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.24167 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5ZM15.8333 15.8333H4.16667V13.3333H7.13333C7.70833 14.325 8.775 15 10.0083 15C11.2417 15 12.3 14.325 12.8833 13.3333H15.8333V15.8333ZM15.8333 11.6667H11.675C11.675 12.5833 10.925 13.3333 10.0083 13.3333C9.09167 13.3333 8.34167 12.5833 8.34167 11.6667H4.16667V4.16667H15.8333V11.6667Z" />
  </Icon>
);

export default memo(InboxOutlineIcon);
